export function generateDownloadFileLink(file: Blob, fileName: string): void {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(file);
  link.download = fileName;

  link.click();
  link.remove();
}

// A extensão não é confiável (há PDFs gravados como .jpg), então só vale como imagem o que o navegador consegue carregar
export function isViewableImage(url: string): Promise<boolean> {
  const path = url.split('?')[0].toLowerCase();
  if (path.endsWith('.pdf')) return Promise.resolve(false);
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

type StoredFile = { url: string; filename: string; contentType: string };

function fileNameFromUrl(url: string): string {
  return decodeURIComponent(url.split('?')[0].split('/').pop() ?? 'documento.pdf');
}

// Separa os anexos entre o que vai para o carrossel e o que vira link de download.
// Com FILES o tipo vem do storage; sem ele (backend antigo) testa se o navegador carrega a URL.
export async function splitAttachments(feedback: Readonly<{ IMAGES?: string[]; FILES?: StoredFile[] }>): Promise<{
  images: string[];
  documents: { url: string; name: string; contentType?: string }[];
}> {
  if (feedback.FILES) {
    const isImage = (file: StoredFile) => file.contentType.startsWith('image/');
    return {
      images: feedback.FILES.filter(isImage).map((file) => file.url),
      documents: feedback.FILES.filter((file) => !isImage(file)).map((file) => ({
        url: file.url,
        name: file.filename,
        contentType: file.contentType,
      })),
    };
  }
  const urls = feedback.IMAGES ?? [];
  const viewable = await Promise.all(urls.map(isViewableImage));
  return {
    images: urls.filter((_, i) => viewable[i]),
    documents: urls.filter((_, i) => !viewable[i]).map((url) => ({ url, name: fileNameFromUrl(url) })),
  };
}

const documentTypeLabels: Record<string, string> = {
  'application/pdf': 'PDF',
  'application/zip': 'ZIP',
  'application/x-zip-compressed': 'ZIP',
};

// O tipo do storage vale mais que a extensão: há PDFs antigos gravados como .jpg
export function documentTypeLabel(name: string, contentType?: string): string {
  if (contentType && documentTypeLabels[contentType]) return documentTypeLabels[contentType];
  const ext = name.includes('.') ? name.split('.').pop() : '';
  return (ext ?? '').toUpperCase();
}
